// Nav entry of OwnWords (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'ownWords',
  path: '/own-words',
  icon: 'ownWords',
  group: 'together',
  phone: 'more',
  order: 1200,
  load: () => import('./OwnWords'),
});
